import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createAuth } from '@justgiving/auth';
import { reducer as formReducer } from 'redux-form';
import appReducer from 'reducers';
import { globalAlert } from './components/GlobalAlert/GlobalAlert.reducer';
import koalaMiddleware from 'reduxMiddleware/analytics';

import { cookieNames } from 'constants';

const auth = createAuth({
  documentOrReq: document,
  authCookieName: cookieNames.authCookieName,
});

const configureStore = (initialState = {}) => {
  const middleware = [thunk.withExtraArgument(auth), koalaMiddleware];

  const reducer = combineReducers({
    app: appReducer,
    form: formReducer,
    globalAlert,
  });

  const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware)),
  );

  return store;
};

export default configureStore;
